import { Sheet } from '../components/Sheet.jsx';
import { Icon } from '../components/Icon.jsx';
import { fileUrl } from '../lib/api.js';
import { dayLabel } from '../lib/format.js';
import { extClass, extOf, isImageName } from '../lib/files.js';

/** Vorschau: Bilder direkt, PDFs und andere Dateien im neuen Tab (native Viewer am Handy). */
export function FileViewer({ file, where, onClose }) {
  const url = fileUrl(file.id);
  const image = isImageName(file.name);
  return (
    <Sheet title={image ? 'Foto' : 'Datei'} onClose={onClose}>
      <div style={{ minHeight: 220, maxHeight: '55vh', borderRadius: 18, background: '#E9EEEC', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        {image
          ? <img src={url} alt={file.name} style={{ maxWidth: '100%', maxHeight: '55vh', objectFit: 'contain' }} />
          : <span className={`ext ${extClass(file.name)}`} style={{ width: 96, height: 96, borderRadius: 20, fontSize: 20 }}>{extOf(file.name)}</span>}
      </div>
      <div className="stack" style={{ gap: 2 }}>
        <span style={{ fontSize: 17, fontWeight: 800, wordBreak: 'break-word' }}>{file.name}</span>
        <span className="sub">{[where, file.datum ? dayLabel(file.datum.slice(0, 10)) : null].filter(Boolean).join(' · ')}</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 10 }}>
        <a className="btn secondary" href={url} download={file.name} style={{ textDecoration: 'none' }}><Icon name="upload" style={{ transform: 'rotate(180deg)' }} />Speichern</a>
        <a className="btn" href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><Icon name="external" />Öffnen</a>
      </div>
    </Sheet>
  );
}
